import { useMemo } from 'react';
import { useDataTable } from '../../../modules/table/DataTable';
import { formatPriceToBRL } from '../../../helpers/formatPriceToBRL';
import { type ManagerBillTotalsDto } from '../core/_models';

const BillStatusTabNav = () => {
  const { filter, updateFilter, clearFilter, dataAdditionalContent } = useDataTable();

  const totals = useMemo(() => dataAdditionalContent as ManagerBillTotalsDto, [dataAdditionalContent]);

  const handleTabClick = (statusUpdated?: string) => {
    if (statusUpdated) {
      updateFilter({ ...filter, status: statusUpdated });
    } else {
      clearFilter('status');
    }
  };

  const tabClass = (status?: string) => {
    const isActive = status ? filter?.status === status : !filter?.status;
    return `d-flex flex-column align-items-center nav-link ${isActive ? 'active fw-bold text-gray-700' : ''}`;
  };

  return (
    <ul
      className="nav nav-tabs nav-line-tabs my-5 fs-6 d-flex flex-nowrap overflow-auto"
      style={{
        paddingBottom: '1px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <li className="nav-item">
        <a className={tabClass()} role="button" onClick={() => handleTabClick()}>
          <span>todas</span>
          <span className="text-truncate">{formatPriceToBRL(totals?.total_amount || 0)}</span>
        </a>
      </li>
      <li className="nav-item">
        <a className={tabClass('OPENED')} role="button" onClick={() => handleTabClick('OPENED')}>
          <span>em aberto</span>
          <span className="text-truncate">{formatPriceToBRL(totals?.total_opened || 0)}</span>
        </a>
      </li>
      <li className="nav-item">
        <a className={tabClass('PAID')} role="button" onClick={() => handleTabClick('PAID')}>
          <span>pagas</span>
          <span className="text-truncate">{formatPriceToBRL(totals?.total_paid || 0)}</span>
        </a>
      </li>
      <li className="nav-item">
        <a className={tabClass('DELAYED')} role="button" onClick={() => handleTabClick('DELAYED')}>
          <span>atrasadas</span>
          <span className="text-truncate">{formatPriceToBRL(totals?.total_delayed || 0)}</span>
        </a>
      </li>
      <li className="nav-item">
        <a className={tabClass('CANCELED')} role="button" onClick={() => handleTabClick('CANCELED')}>
          <span>canceladas</span>
          <span className="text-truncate">{formatPriceToBRL(totals?.total_canceled || 0)}</span>
        </a>
      </li>
    </ul>
  );
};

export default BillStatusTabNav;
